import React from 'react'
import {
  IconDashboard,
  IconDevices,
  IconListCheck,
  IconMapPin,
  IconPlugConnected,
  IconRadar,
  IconRadar2,
  IconUrgent,
  IconUsers,
  IconUsersGroup,
} from '@tabler/icons-react'
import { RoleType } from '../types/UserTypes'

export interface navType {
  type: string
  display: string
  roles: RoleType[]
  paths?: string[]
  items?: navType[]
  additionalRequirements?: string[]
  icon?: React.ReactNode
}

export const navItems: navType[] = [
  {
    type: 'DASHBOARD',
    display: 'Dashboard',
    roles: [],
    icon: React.createElement(IconDashboard, { size: 18 }),
  },
  {
    type: 'ALERTS',
    display: 'Alerts',
    roles: [],
    icon: React.createElement(IconUrgent, { size: 18 }),
  },
  {
    type: 'DEVICES',
    display: 'Devices',
    roles: [],
    icon: React.createElement(IconDevices, { size: 18 }),
  },
  {
    type: 'MEMBERS',
    display: 'Members',
    roles: [],
    icon: React.createElement(IconUsers, { size: 18 }),
  },
  {
    type: 'GROUPS',
    display: 'Groups',
    roles: [RoleType.SUPER_ADMIN],
    icon: React.createElement(IconUsersGroup, { size: 18 }),
  },
  {
    type: 'TRAVEL',
    display: 'Location Insights',
    roles: [],
    additionalRequirements: ['sensitiveTravel'],
    icon: React.createElement(IconMapPin, { size: 18 }),
  },
  {
    type: 'INTEGRATIONS',
    display: 'Integrations',
    roles: [RoleType.PLATFORM_MGMT],
    icon: React.createElement(IconPlugConnected, { size: 18 }),
  },
  {
    type: 'THREAT-HUNTER',
    display: 'Threat Hunter',
    roles: [RoleType.SUPER_ADMIN, RoleType.PLATFORM_MGMT],
    icon: React.createElement(IconRadar2, { size: 18 }),
    additionalRequirements: ['threatHunterAccess'],
  },
  {
    type: 'PROTECTION_MEASURES',
    display: 'Policies',
    roles: [],
    icon: React.createElement(IconListCheck, { size: 18 }),
    paths: ['blocklist', 'device-policies'],
    items: [
      {
        type: 'DEVICE-POLICIES',
        display: 'Device Policies',
        roles: [RoleType.PLATFORM_MGMT, RoleType.ACCESS_MGMT],
      },
      {
        type: 'BLOCKLIST',
        display: 'Domain Blocklist',
        roles: [],
      },
    ],
  },
  {
    type: 'THREAT_INTELLIGENCE',
    display: 'Threat Intel',
    roles: [RoleType.SUPER_ADMIN],
    additionalRequirements: ['threatIntelAccess'],
    paths: ['adversaries', 'intel-reports', 'visualizations', 'victimology'],
    icon: React.createElement(IconRadar, { size: 18 }),
    items: [
      {
        type: 'ADVERSARIES',
        display: 'Adversaries',
        roles: [RoleType.SUPER_ADMIN],
        additionalRequirements: ['threatIntelAccess'],
      },
      {
        type: 'INTEL-REPORTS',
        display: 'Reports',
        roles: [RoleType.SUPER_ADMIN],
        additionalRequirements: ['threatIntelAccess'],
      },
      {
        type: 'VISUALIZATIONS',
        display: 'Visualizations',
        roles: [RoleType.SUPER_ADMIN],
        additionalRequirements: ['threatIntelAccess'],
      },
      {
        type: 'VICTIMOLOGY',
        display: 'Victimology',
        roles: [RoleType.SUPER_ADMIN],
        additionalRequirements: ['threatIntelAccess', 'threatIntelEvaluation'],
      },
    ],
  },
]
